import { setKey, fromAddress, geocode } from "react-geocode";
import { forwardEntitlementParams } from "../features/player/entitlements";
import { toast } from "react-toastify";
import { scoreMagicMinMaxValues } from "../pages/organizer/forms/formSelectArrays";
import { shareRowQuery } from "./eventShareRow";

import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
setKey(process.env.REACT_APP_GEOCODE_API_KEY);

export function CalculateHeadToHeadFilteredStats(
  shouldCalculate,
  gridRef,
  setFiltered
) {
  if (shouldCalculate) {
    let filteredStats = {
      inFourTotal: 0,
      inTotal: 0,
      offTotal: 0,
      onTotal: 0,
      totalRounds: 0,
      totalLosses: 0,
      totalPointsAgainst: 0,
      totalPointsFor: 0,
      totalNetPointsAgainst: 0,
      totalNetPointsFor: 0,
      totalTies: 0,
      totalWins: 0,
    };
    console.log(
      "gridRef.current.api.getDisplayedRowCount(): ",
      gridRef.current.api.getDisplayedRowCount()
    );
    //If there's no filtered rows, set all to 0
    if (gridRef.current.api.getDisplayedRowCount() === 0) {
      setFiltered(filteredStats);
    }
    //allNodes array is just for console log reference. Not being used anywhere
    let allNodes = [];
    gridRef.current.api.forEachNodeAfterFilter((node) => {
      //node.data
      const matchup = node.data;
      console.log("node: ", node);
      console.log("matchup: ", matchup);
      allNodes.push(matchup);
      const nodeStatsObj = {
        totalLosses:
          matchup.outcome === 0
            ? filteredStats.totalLosses + 1
            : filteredStats.totalLosses,
        totalNetPointsAgainst:
          filteredStats.totalNetPointsAgainst + matchup.totalNetPointsAgainst,
        totalPointsAgainst:
          filteredStats.totalPointsAgainst + matchup.totalPointsAgainst,
        totalPointsFor:
          filteredStats.totalPointsFor + Number(matchup.totalPointsFor),
        totalNetPointsFor:
          filteredStats.totalNetPointsFor + Number(matchup.totalNetPointsFor),
        totalTies:
          matchup.outcome === 2
            ? filteredStats.totalTies + 1
            : filteredStats.totalTies,
        totalWins:
          matchup.outcome === 1
            ? filteredStats.totalWins + 1
            : filteredStats.totalWins,
        inFourTotal: filteredStats.inFourTotal + matchup.inFourTotal,
        inTotal: filteredStats.inTotal + matchup.inTotal,
        offTotal: filteredStats.offTotal + matchup.offTotal,
        onTotal: filteredStats.onTotal + matchup.onTotal,
        totalRounds: filteredStats.totalRounds + matchup.totalRounds,
      };
      filteredStats = nodeStatsObj;
      console.log("nodeStatsObj: ", nodeStatsObj);
    });
    function GetStatPercentage(stat, bags) {
      const newValue = Math.round(
        (stat /
          (bags ? filteredStats.totalRounds * 4 : filteredStats.totalRounds)) *
          100
      );
      if (Number.isNaN(newValue)) {
        return 0;
      } else {
        return newValue;
      }
    }
    const calculatedScoremagicValues = {
      inFourPercent: GetStatPercentage(filteredStats.inFourTotal),
      inPercent: GetStatPercentage(filteredStats.inTotal, true),
      offPercent: GetStatPercentage(filteredStats.offTotal, true),
      onPercent: GetStatPercentage(filteredStats.onTotal, true),
      oppr: GetStatPercentage(filteredStats.totalPointsAgainst) / 100,
      ppr: GetStatPercentage(filteredStats.totalPointsFor) / 100,
      dpr:
        Math.round(
          (GetStatPercentage(filteredStats.totalPointsFor) / 100 -
            GetStatPercentage(filteredStats.totalPointsAgainst) / 100) *
            100
        ) / 100,
    };
    console.log("filteredStats: ", filteredStats);
    console.log("calculatedScoremagicValues: ", calculatedScoremagicValues);
    console.log("allNodes: ", allNodes);
    setFiltered({
      ...filteredStats,
      ...calculatedScoremagicValues,
    });
    console.log("SHOULD HAVE SET FILTERED");
  } else {
    setFiltered(null);
  }
}

export function ConvertWYSIWYGData(data) {
    const blocksFromHTML = convertFromHTML(data);
    const contentState = ContentState.createFromBlockArray(
      blocksFromHTML.contentBlocks,
      blocksFromHTML.entityMap
    );

    return EditorState.createWithContent(contentState);
  }

export function CalculateGhostholioFilteredStats(
  shouldCalculate,
  gridRef,
  setFiltered
) {
  if (shouldCalculate) {
    let filteredStats = {
      totalFourIn: 0,
      totalIn: 0,
      totalOff: 0,
      totalOn: 0,
      totalPoints: 0,
      bestGhost: 0,
      bestGhostLevel: "None",
      totalRounds: 0,
    };
    console.log(
      "gridRef.current.api.getDisplayedRowCount(): ",
      gridRef.current.api.getDisplayedRowCount()
    );
    console.log("gridRef.current ", gridRef.current);
    //allNodes array is just for console log reference. Not being used anywhere
    let allNodes = [];
    function CheckDifficultyLevel(outcome, level) {
      let ghostLevel = "Easy";
      switch (level) {
        case 0:
          ghostLevel = "Easy";
          break;
        case 1:
          ghostLevel = "Jinx";
          break;
        case 2:
          ghostLevel = "Ben";
          break;
        case 3:
          ghostLevel = "Medium";
          break;
        case 4:
          ghostLevel = "Hard";
          break;
        case 5:
          ghostLevel = "Whittmart";
          break;
        case 6:
          ghostLevel = "Expert";
          break;
        default:
          ghostLevel = "Easy";
          break;
      }
      return ghostLevel;
    }
    //If there's no filtered rows, set all to 0
    console.log(
      "gridRef.current.api.getDisplayedRowCount(): ",
      gridRef.current.api.getDisplayedRowCount()
    );
    if (gridRef.current.api.getDisplayedRowCount() === 0) {
      setFiltered(filteredStats);
    }
    gridRef.current.api.forEachNodeAfterFilter((node, index) => {
      //node.data
      console.log("node: ", node);
      console.log("index: ", index);

      if (
        // index === 0
        (index === 0 && !node.childrenAfterFilter) ||
        (index > 0 && !node.data)
      ) {
        console.log("SET FILTERED TO 0");
        setFiltered(filteredStats);
      } else {
        const matchup =
          index === 0 || !node.hasOwnProperty("data")
            ? node.childrenAfterFilter[index].data
            : node.data;
        console.log("matchup: ", matchup);
        if (
          matchup &&
          !allNodes.find((e) => e.practiceid === matchup.practiceid)
        ) {
          const matchup =
            index === 0 ? node.childrenAfterFilter[index].data : node.data;
          console.log("matchup: ", matchup);
          allNodes.push(matchup);
          const nodeStatsObj = {
            totalFourIn: filteredStats.totalFourIn + matchup.totalfourbagger,
            totalIn: filteredStats.totalIn + matchup.totalin,
            totalOff: filteredStats.totalOff + matchup.totaloff,
            totalOn: filteredStats.totalOn + matchup.totalon,
            totalPoints: filteredStats.totalPoints + matchup.totalscore,
            totalRounds: filteredStats.totalRounds + matchup.totalrounds,
            bestGhostLevel:
              matchup.outcome === 1
                ? CheckDifficultyLevel()
                : filteredStats.bestGhostLevel,
            bestGhost:
              matchup.outcome === 1
                ? Math.round(matchup.avgopp * 100) / 100
                : filteredStats.bestGhost,
          };
          filteredStats = nodeStatsObj;
          console.log("nodeStatsObj: ", nodeStatsObj);
        }
      }
    });

    function GetStatPercentage(stat, bags) {
      const newValue = Math.round(
        (stat /
          (bags ? filteredStats.totalRounds * 4 : filteredStats.totalRounds)) *
          100
      );
      if (Number.isNaN(newValue)) {
        return 0;
      } else {
        return newValue;
      }
    }
    const calculatedScoremagicValues = {
      avgPpr: GetStatPercentage(filteredStats.totalPoints) / 100,
      totalFourInPercent: GetStatPercentage(filteredStats.totalFourIn),
      totalInPercent: GetStatPercentage(filteredStats.totalIn, true),
      totalOffPercent: GetStatPercentage(filteredStats.totalOff, true),
      totalOnPercent: GetStatPercentage(filteredStats.totalOn, true),
    };
    console.log("filteredStats: ", filteredStats);
    console.log("calculatedScoremagicValues: ", calculatedScoremagicValues);
    console.log("allNodes: ", allNodes);
    setFiltered({
      ...filteredStats,
      ...calculatedScoremagicValues,
    });
  } else {
    setFiltered(null);
  }
}

export function CalculateDecaholioFilteredStats(
  shouldCalculate,
  gridRef,
  setFiltered
) {
  if (shouldCalculate) {
    let filteredStats = {
      totalFourIn: 0,
      totalIn: 0,
      totalOff: 0,
      totalOn: 0,
      totalPoints: 0,
      bestRound: 0,
      totalRounds: 0,
    };
    console.log(
      "gridRef.current.api.getDisplayedRowCount(): ",
      gridRef.current.api.getDisplayedRowCount()
    );
    console.log("gridRef.current ", gridRef.current);
    //allNodes array is just for console log reference. Not being used anywhere
    let allNodes = [];
    //If there's no filtered rows, set all to 0
    if (gridRef.current.api.getDisplayedRowCount() === 0) {
      setFiltered(filteredStats);
    }
    gridRef.current.api.forEachNodeAfterFilter((node, index) => {
      //node.data
      console.log("index: ", index);
      console.log("node: ", node);
      console.log(
        "index === 0 && !node.childrenAfterFilter: ",
        index === 0 && !node.childrenAfterFilter
      );
      console.log("index > 0 && !node.data: ", index > 0 && !node.data);

      if (
        // index === 0
        (index === 0 && !node.childrenAfterFilter) ||
        (index > 0 && !node.data)
      ) {
        console.log("SET FILTERED TO 0");
        setFiltered(filteredStats);
      } else {
        const matchup =
          index === 0 || !node.hasOwnProperty("data")
            ? node.childrenAfterFilter[index].data
            : node.data;
        console.log("matchup: ", matchup);
        if (
          matchup &&
          !allNodes.find((e) => e.practiceid === matchup.practiceid)
        ) {
          console.log("setting nodeStatsObj from matchup");
          allNodes.push(matchup);
          const nodeStatsObj = {
            totalFourIn: filteredStats.totalFourIn + matchup.totalfourbagger,
            totalIn: filteredStats.totalIn + matchup.totalin,
            totalOff: filteredStats.totalOff + matchup.totaloff,
            totalOn: filteredStats.totalOn + matchup.totalon,
            totalPoints: filteredStats.totalPoints + matchup.totalscore,
            totalRounds: filteredStats.totalRounds + matchup.totalrounds,
            bestRound:
              filteredStats.bestRound < matchup.overallscoreteam1
                ? matchup.overallscoreteam1
                : filteredStats.bestRound,
          };
          filteredStats = nodeStatsObj;
          console.log("nodeStatsObj: ", nodeStatsObj);
        }
      }
    });
    console.log("allNodes: ", allNodes);
    function GetStatPercentage(stat, bags) {
      const newValue = Math.round(
        (stat /
          (bags ? filteredStats.totalRounds * 4 : filteredStats.totalRounds)) *
          100
      );
      if (Number.isNaN(newValue)) {
        return 0;
      } else {
        return newValue;
      }
    }
    const calculatedScoremagicValues = {
      avgPpr: GetStatPercentage(filteredStats.totalPoints) / 100,
      totalFourInPercent: GetStatPercentage(filteredStats.totalFourIn),
      totalInPercent: GetStatPercentage(filteredStats.totalIn, true),
      totalOffPercent: GetStatPercentage(filteredStats.totalOff, true),
      totalOnPercent: GetStatPercentage(filteredStats.totalOn, true),
    };
    console.log("filteredStats: ", filteredStats);
    console.log("calculatedScoremagicValues: ", calculatedScoremagicValues);
    console.log("allNodes: ", allNodes);
    setFiltered({
      ...filteredStats,
      ...calculatedScoremagicValues,
    });
  } else {
    setFiltered(null);
  }
}

export function RefreshPlayerProfileURL() {
  try {
    window.Android.refreshPlayerProfileURL();
  } catch (err) {
    console.log("android refreshPlayerProfileURL fail");
  }
  try {
    window.webkit.messageHandlers.refreshPlayerProfileURL.postMessage(
      "refreshPlayerProfileURL"
    );
  } catch (err) {
    console.log("webkit refreshPlayerProfileURL fail");
  }
}

/**
 * Resolves a Branch.io shortened URL to its full deep link data.
 * Uses the Branch Read Existing Deep Link API:
 * GET https://api2.branch.io/v1/url?url={url}&branch_key={key}
 *
 * @param {string} shortUrl - e.g. "https://share.scoreholio.com/Mulh2ckoIZb"
 * @returns {Promise<object|null>} - The `data` payload from Branch, or null on failure
 *
 * Useful data fields in the response:
 *   data.$deeplink_path  — the in-app path to navigate to
 *   data.$ios_url / data.$android_url — platform overrides
 *   Any custom key/value pairs set when the link was created
 */
export async function resolveBranchLink(shortUrl) {
  const branchKey = process.env.REACT_APP_BRANCH_KEY;
  if (!branchKey) {
    console.warn("REACT_APP_BRANCH_KEY is not set");
    return null;
  }
  try {
    const apiUrl = `https://api2.branch.io/v1/url?url=${encodeURIComponent(shortUrl)}&branch_key=${branchKey}`;
    const res = await fetch(apiUrl);
    if (!res.ok) {
      console.error("Branch API error:", res.status, await res.text());
      return null;
    }
    const json = await res.json();
    return json?.data ?? null;
  } catch (err) {
    console.error("Failed to resolve Branch link:", err);
    return null;
  }
}

export function SetEventColor(opacity, teamcreate, pastelRed) {
  let color = "#fff";
  switch (teamcreate) {
    case "Singles":
      color = `#d07a2d` + `${opacity}`;
      break;
    case "Blind Draw":
      color = `#43922a` + `${opacity}`;
      break;
    case "Set Teams":
      color = `#3576a4` + `${opacity}`;
      break;
    case "Switcholio":
      color = `#4b3179` + `${opacity}`;
      break;
    case "Split Switch":
      color = pastelRed ? "#e58586" : `#CC0C0D` + `${opacity}`;
      break;
    case "Squadholio":
      color = `#bb9b34` + `${opacity}`;
      break;
    case "MultiMatch":
      color = `#5D3911` + `${opacity}`;
      break;
    default:
      color = `#333` + `${opacity}`;
      break;
  }
  return color;
}

export function FieldTerminology(sport, singular) {
  let courtTerminology = "Courts";
  let maxScoreTerminology = "Score Limit";
  switch (sport) {
    case "axethrowing":
      courtTerminology = singular ? "Lane" : "Lanes";
      maxScoreTerminology = "Score Limit";
      break;
    case "darts":
      courtTerminology = singular ? "Board" : "Boards";
      maxScoreTerminology = "Race To";
      break;
    case "billiards":
      courtTerminology = singular ? "Table" : "Tables";
      maxScoreTerminology = "Race To";
      break;
    case ("pong", "tableshuffleboard", "tabletennis", "beerpong"):
      courtTerminology = singular ? "Table" : "Tables";
      maxScoreTerminology = "Game To";
      break;
    case ("tennis", "volleyball", "pickleball", "other", "bocce", "21bust", 'popdarts'):
      courtTerminology = singular ? "Court" : "Courts";
      maxScoreTerminology = "Game To";
      break;
    case "horseshoes":
      courtTerminology = singular ? "Pit" : "Pits";
      maxScoreTerminology = "Game To";
      break;
    default:
      //Cornhole or anything else
      courtTerminology = singular ? "Court" : "Courts";
      maxScoreTerminology = "Score Limit";
  }
  return { courtTerminology, maxScoreTerminology };
}

export function appendLang(url) {
  const lang = localStorage.getItem("scoreholio_lang") || "en";
  try {
    const u = new URL(url);
    if (!u.searchParams.has("lang")) {
      u.searchParams.set("lang", lang);
    }
    return u.toString();
  } catch {
    const sep = url.includes("?") ? "&" : "?";
    return `${url}${sep}lang=${lang}`;
  }
}

export function OpenExternalURL(url, platform) {
  console.log("openexternalurl: ", url, platform);
  // toast.success("url: " + url);
  // toast.success("platform: " + platform);
  if (platform) {
    try {
      try {
        window.Android.openExternalURL(url);
      } catch (err) {
        console.log("android fail openExternalURL");
      }
      try {
        // toast.success("ios hit");
        window.webkit.messageHandlers.openExternalURL.postMessage(url);
      } catch (err) {
        // toast.success("webkit fail openExternalURL");
        console.log("webkit fail openExternalURL");
      }
    } catch (err) {
      console.log("OpenExternalURL error: ", err);
      const win = window.open(appendLang(url), "_blank");
      if (win) win.focus();
    }
  } else {
    // toast.success("final else");
    const win = window.open(appendLang(url), "_blank");
    if (win) win.focus();
  }
}

export function openTournamentLink(url, platform) {
  // toast.success("openTournamentLink hit/platform: " + platform);
  const isUrlRoute =
    window.location.pathname.includes("/groups") ||
    window.location.pathname.includes("/findclub");
  if (platform && window.location.pathname.includes("/findtournament")) {
    const tournamentId = url.split("/").pop();
    const currentParams = new URLSearchParams(window.location.search);
    const sport = window.location.pathname.split("/")[2];
    const queryParams = new URLSearchParams();
    if (currentParams.get("location"))
      queryParams.set("location", currentParams.get("location"));
    if (currentParams.get("lat"))
      queryParams.set("lat", currentParams.get("lat"));
    if (currentParams.get("lng"))
      queryParams.set("lng", currentParams.get("lng"));
    queryParams.set("customType", "Tournament");
    queryParams.set("customId", tournamentId);
    queryParams.set("cache", Date.now());
    queryParams.set("platform", platform);
    const newUrl = `${window.location.origin}/v2/${sport}/player/findtournament?${queryParams.toString()}`;
    // toast.info("openTournamentLink [findtournament] resolvedUrl: " + url, { autoClose: false });
    // toast.info("openTournamentLink [findtournament] tournamentId: " + tournamentId + " | sport: " + sport, { autoClose: false });
    // toast.info("openTournamentLink [findtournament] FINAL URL: " + newUrl, { autoClose: false });
    window.location.href = newUrl;
    return;
  }
  if (platform) {
    try {
      try {
        window.Android.launchTournament(url);
      } catch (err) {
        console.log("android fail launchTournament");
      }
      try {
        // const appdata = isUrlRoute ? { url } : { gameDashUrl: url };
        let appdata = {};
        if (isUrlRoute) {
          appdata = { url };
        } else {
          appdata.gameDashUrl = url;
        }
        // toast.error("trying webkit launchTournament with url: " + url + " and appdata: " + JSON.stringify(appdata), { autoClose: false });
        window.webkit.messageHandlers.launchTournament.postMessage(
          JSON.stringify(appdata),
        );
      } catch (err) {
        // toast.error("webkit fail launchTournament" + err, { autoClose: false });
        console.log("webkit fail launchTournament");
      }
    } catch (err) {
      console.log("openTournamentLink error: ", err);
      const win = window.open(appendLang(url), "_blank");
      if (win) win.focus();
    }
  } else {
    const win = window.open(appendLang(url), "_blank");
    if (win) win.focus();
  }
}

export function ordinal_suffix_of(i) {
  var j = i % 10,
    k = i % 100;
  if (j == 1 && k != 11) {
    return i + "st";
  }
  if (j == 2 && k != 12) {
    return i + "nd";
  }
  if (j == 3 && k != 13) {
    return i + "rd";
  }
  return i + "th";
}

export function LaunchDash(platform, player, url) {
  console.log("LaunchDash platform, player, url: ", platform, player, url);
  if (platform || player.build > 0) {
    try {
      try {
        window.Android.launchDash(url);
      } catch (err) {
        console.log("android fail");
      }
      try {
        let appdata = {};
        appdata.gameDashUrl = url;
        appdata.url = url;
        window.webkit.messageHandlers.launchDash.postMessage(
          JSON.stringify(appdata)
        );
      } catch (err) {
        console.log("webkit fail");
      }
    } catch (err) {
      console.log("LaunchUrl error: ", err);
      const win = window.open(appendLang(url), "_blank");
      if (win) win.focus();
    }
  } else {
    const win = window.open(appendLang(url), "_blank");
    if (win) win.focus();
  }
}

export function LaunchPromo(platform, player, url, title) {
  console.log("LaunchPromo platform, player, url: ", platform, player, url);
  if (platform || player.build > 0) {
    try {
      try {
        window.Android.launchPromo(url, title);
      } catch (err) {
        console.log("android fail");
      }
      try {
        let appdata = {};
        appdata.gameDashUrl = url;
        appdata.gameDashTitle = title;
        window.webkit.messageHandlers.launchPromo.postMessage(
          JSON.stringify(appdata)
        );
      } catch (err) {
        console.log("webkit fail");
      }
    } catch (err) {
      console.log("LaunchUrl error: ", err);
      const win = window.open(url, "_blank");
      if (win) win.focus();
    }
  } else {
    const win = window.open(url, "_blank");
    if (win) win.focus();
  }
}

export function OpenUpgrade(platform, navType, toast) {
  if (!platform && navType === "organizer") {
    toast.error("Please upgrade in app!", {
      autoClose: 5000,
      hideProgressBar: true,
    });
  } else {
    try {
      window.Android.openUpgrade();
    } catch (err) {
      console.log("android fail");
    }
    try {
      window.webkit.messageHandlers.openUpgrade.postMessage(
        '{"status":"upgrade"}'
      );
    } catch (err) {
      console.log("webkit fail");
    }
  }
}

export function SetCustomTheme(platform, type) {
  if (platform || platform === "none") {
    try {
      window.Android.setCustomTheme(type);
    } catch (err) {
      console.log("android fail");
    }
    try {
      window.webkit.messageHandlers.setCustomTheme.postMessage(type);
    } catch (err) {
      console.log("webkit fail");
    }
  }
}

// No platform gate: must fire even if the platform param was lost (web = silent no-op)
export function LogoutPlayerProfileNative() {
  try {
    window.Android.logoutPlayerProfile();
  } catch (err) {
    console.log("android fail");
  }
  try {
    window.webkit.messageHandlers.logoutPlayerProfile.postMessage("logout");
  } catch (err) {
    console.log("webkit fail");
  }
}

export function NumberArray(num) {
  var arr = [];
  for (var i = 0; i < num; i++) {
    arr.push({ name: i, id: i });
  }
  return arr;
}

export function SportGameTimers(sport) {
  let timer = 15;
  switch (sport) {
    case "billiards":
    case "cornhole":
    case "tabletennis":
    case "popdarts":
      timer = 15;
      break;
    case "bocce":
      timer = 40;
      break;
    case "darts":
    case "pong":
      timer = 10;
      break;
    case "tableshuffleboard":
      timer = 45;
      break;
    case "horseshoes":
    case "pickleball":
      timer = 20;
      break;
    case "volleyball":
      timer = 25;
      break;
    case "tennis":
      timer = 30;
      break;
    default:
      break;
  }
  return timer;
}

export function findTournamentFilterReducer(state, action) {
  console.log("reducer action: ", action);
  switch (action.type) {
    case "sort": {
      return {
        ...state,
        sort: action.sort,
      };
    }
    case "distance": {
      return {
        ...state,
        distance: action.distance,
      };
    }
    case "lat": {
      return {
        ...state,
        lat: action.lat,
      };
    }
    case "lng": {
      return {
        ...state,
        lng: action.lng,
      };
    }
    case "customLat": {
      return {
        ...state,
        customLat: action.customLat,
      };
    }
    case "customLng": {
      return {
        ...state,
        customLng: action.customLng,
      };
    }
    case "customAddress": {
      return {
        ...state,
        customAddress: action.customAddress,
      };
    }
    case "custom_distance": {
      return {
        ...state,
        customDistance: action.customDistance,
      };
    }
    case "show_custom_distance": {
      return {
        ...state,
        showCustomDistance: action.showCustomDistance,
      };
    }
    case "generation": {
      return {
        ...state,
        generation: action.generation,
      };
    }
    case "favorites": {
      return {
        ...state,
        favorites: action.favorites,
      };
    }
    case "date_start": {
      return {
        ...state,
        dateStart: action.dateStart,
      };
    }
    case "date_end": {
      return {
        ...state,
        dateEnd: action.dateEnd,
      };
    }
    case "mineUpcoming": {
      return {
        ...state,
        mineUpcoming: action.mineUpcoming,
      };
    }
    case "mine_player": {
      return {
        ...state,
        minePlayer: action.minePlayer,
      };
    }
    case "mine_organizer": {
      return {
        ...state,
        mineOrganizer: action.mineOrganizer,
      };
    }
    case "preReg": {
      return { ...state, preReg: action.preReg };
    }
    case "openSpots": {
      return { ...state, openSpots: action.openSpots };
    }
    case "format": {
      return { ...state, format: action.format };
    }
    case "handicap": {
      return { ...state, handicap: action.handicap };
    }
    case "hasWaitlist": {
      return { ...state, hasWaitlist: action.hasWaitlist };
    }
    case "status": {
      return { ...state, status: action.status };
    }
    case "clearFilters": {
      return {
        ...state,
        showCustomDistance: false,
        favorites: false,
        sort: false,
        generation: "All",
        distance: 100,
        resetURLParams: true,
        preReg: false,
        openSpots: false,
        format: "All",
        handicap: false,
        hasWaitlist: false,
        status: "All",
      };
    }
    default:
      break;
  }
  throw Error("Unknown action: " + action.type);
}
export function findClubFilterReducer(state, action) {
  console.log("reducer action: ", action);
  switch (action.type) {
    case "sort": {
      return {
        ...state,
        sort: action.sort,
      };
    }
    case "distance": {
      return {
        ...state,
        distance: action.distance,
      };
    }
    case "lat": {
      return {
        ...state,
        lat: action.lat,
      };
    }
    case "lng": {
      return {
        ...state,
        lng: action.lng,
      };
    }
    case "customLat": {
      return {
        ...state,
        customLat: action.customLat,
      };
    }
    case "customLng": {
      return {
        ...state,
        customLng: action.customLng,
      };
    }
    case "customAddress": {
      return {
        ...state,
        customAddress: action.customAddress,
      };
    }
    case "custom_distance": {
      return {
        ...state,
        customDistance: action.customDistance,
      };
    }
    case "show_custom_distance": {
      return {
        ...state,
        showCustomDistance: action.showCustomDistance,
      };
    }
    case "generation": {
      return {
        ...state,
        generation: action.generation,
      };
    }
    case "favorites": {
      return {
        ...state,
        favorites: action.favorites,
      };
    }
    case "date_start": {
      return {
        ...state,
        dateStart: action.dateStart,
      };
    }
    case "date_end": {
      return {
        ...state,
        dateEnd: action.dateEnd,
      };
    }
    case "mineUpcoming": {
      return {
        ...state,
        mineUpcoming: action.mineUpcoming,
      };
    }
    case "mine_player": {
      return {
        ...state,
        minePlayer: action.minePlayer,
      };
    }
    case "mine_organizer": {
      return {
        ...state,
        mineOrganizer: action.mineOrganizer,
      };
    }
    case "clearFilters": {
      return {
        ...state,
        showCustomDistance: false,
        favorites: false,
        sort: false,
        generation: "All",
        distance: 10000,
        resetURLParams: true,
      };
    }
    default:
      break;
  }
  throw Error("Unknown action: " + action.type);
}

export function FormatRestrictionValues(restrictions, sport) {
  let formattedRestrictions = {};
  let error = null;
  Object.entries(restrictions).forEach((item) => {
    console.log("FormattedRestrictionValues item: ", item);
    
    // Skip min/max parsing for boolean-only restrictions
    const isBooleanOnly = ["duprExists", "inviteList", "inviteInclude", "inviteExclude"].includes(item[0]);
    
    // For invite restrictions, exclude min/max from the formatted output
    if (["inviteList", "inviteInclude", "inviteExclude"].includes(item[0])) {
      const { min, max, ...restWithoutMinMax } = item[1];
      formattedRestrictions[item[0]] = restWithoutMinMax;
      return;
    }
    
    formattedRestrictions[item[0]] = {
      ...item[1],
      min: isBooleanOnly ? item[1].min : parseFloat(item[1].min),
      max: isBooleanOnly ? item[1].max : parseFloat(item[1].max),
    };
    
    // Skip validation for boolean-only restrictions
    if (isBooleanOnly) {
      return;
    }
    
    //Check if min/max is less than scoreMagicMinMaxValues, then set an error and disallow form submission
    const r = formattedRestrictions[item[0]];
    const minMaxSport = !["cornhole", "horseshoes"].includes(sport)
      ? "all"
      : sport;
    const minMaxValue = scoreMagicMinMaxValues.find(
      (v) => v.sport === minMaxSport
    )[item[0]];
    console.log("r and minMaxValue: ", r, minMaxValue);
    
    // Only validate if minMaxValue exists (some restrictions may not be in the lookup)
    if (
      minMaxValue &&
      (r.min < minMaxValue.min ||
      r.min > minMaxValue.max ||
      r.max < minMaxValue.min ||
      r.max > minMaxValue.max)
    ) {
      error = `Invalid restriction values for ${item[0].replace(
        "season",
        "Season "
      )}`;
    }
  });
  console.log("FormatRestrictionValues: ", formattedRestrictions);
  if (error) {
    toast.error(error);
    return null;
  } else {
    return formattedRestrictions;
  }
}

/**
 * Tell native to open the event options menu in a modal webview.
 * Method name + payload shape must be confirmed with the native team.
 *
 * @param {object} event  - merged event object with a `role` property
 * @param {string} platform - "ios" | "android" | null
 * @param {string} sport  - e.g. "cornhole"
 */
export function openEventMenu(event, platform, sport) {
  // The hero page's own URL carries the auth params (user=&pin=, SCO-1823
  // contract) — forward them so the menu can build child pages (Scan In /
  // Roster) that need the player identity (SCO-1834).
  const heroParams = new URLSearchParams(window.location.search);
  const menuUrl =
    `/v2/${sport}/home-events/menu` +
    `?game=${event.gameid}` +
    `&account=${event.accountid}` +
    `&roles=${event.role}` +
    `&platform=${platform || ""}` +
    `&name=${encodeURIComponent(event.name || "")}` +
    // dashlink is state-dependent (dashboard / -setup / -bracket…, built
    // server-side per row) — it can't be reconstructed client-side (SCO-1834).
    `&dashlink=${encodeURIComponent(event.dashlink || "")}` +
    `&seasonId=${encodeURIComponent(event.seasonId || "")}` +
    `&hidePreRegNames=${event.hidePreRegNames ? "1" : ""}` +
    `&registered=${event.gameregistered ? "1" : ""}` +
    `&format=${encodeURIComponent(event.format || "")}` +
    // SCO-2349: the menu header matches the hero card's teamcreate gradient.
    `&teamcreate=${encodeURIComponent(event.teamcreate || "")}` +
    // SCO-2456: the row's Branch share link feeds the menu's Share row.
    `&share=${encodeURIComponent(event.dynamiclink || "")}` +
    // SCO-3178: what the Share child's 2027 flyers print.
    shareRowQuery((k) => event[k]) +
    `&user=${heroParams.get("user") || ""}` +
    `&pin=${heroParams.get("pin") || ""}` +
    // SCO-2502: the shell's paid flags + build ride along (present ones only)
    // so the menu's and roster's boot sync see what the hero saw; spr stays
    // for old shells / legacy links that carry no flags.
    forwardEntitlementParams(heroParams) +
    // spr is RegisteredPlayersList's paid-gating override param — derive it
    // from the hero's paid flags (same rule as the match sheet).
    `&spr=${
      ["Yes", "yes", "true", "1"].includes(heroParams.get("paidPlayer")) ||
      ["Yes", "yes", "true", "1"].includes(heroParams.get("paidOrganizer"))
        ? "1"
        : "0"
    }`;

  const payload = JSON.stringify({
    gameid: event.gameid,
    accountid: event.accountid,
    roles: event.role,
    name: event.name,
    url: menuUrl,
  });

  // The slider and the menu live in separate native webviews, so a card tap must
  // always hand off to native (which opens its modal + loads the menu webview).
  // No web navigation fallback — on plain web (no bridge) this is a harmless no-op.
  try {
    window.Android.openEventMenu(payload);
  } catch (e) {
    console.log("android openEventMenu fail");
  }
  try {
    window.webkit.messageHandlers.openEventMenu.postMessage(payload);
  } catch (e) {
    console.log("webkit openEventMenu fail");
  }
}

/**
 * Hand off to native to open the "Find a Tournament" flow. LEGACY bridge —
 * predates the customizable-home hero and is not registered on the hero
 * webview, so `postHomeAction("find", …)` is what actually reaches native
 * from the hero. Kept as a belt-and-suspenders fallback for any other
 * (non-hero) webview that still registers this handler; a no-op elsewhere.
 *
 * @param {string} platform - "ios" | "android" | null
 * @param {string} sport    - e.g. "cornhole"
 */
export function openFindTournament(platform, sport) {
  try {
    window.Android.openFindTournament(sport);
  } catch (e) {
    console.log("android openFindTournament fail");
  }
  try {
    window.webkit.messageHandlers.openFindTournament.postMessage(sport);
  } catch (e) {
    console.log("webkit openFindTournament fail");
  }
}

/**
 * Post a hero deep-link action to native over the customizable-home hero's
 * unified `homeAction` bridge (SCO-1804 vocabulary). The hero webview (iOS
 * HeroWebView / Android equivalent) registers `homeAction` but NOT the older
 * per-flow handlers like `openFindTournament`, so hero-context navigations
 * must go through here. Native routes the action key to the matching home
 * flow — e.g. `find` → the Find a Tournament tab, opened for the sport passed
 * (which is the sport the hero was loaded for); `login` (SCO-1819) → switch
 * to the Player tab, where UnverifiedProfile hosts the player login wizard
 * (native may append ?action=login to the profile URL so the wizard
 * auto-opens, SCO-1820). Used by the empty-state "Find" button, the
 * logged-out widgets' "Log In" button and the hero widget row tap-throughs
 * (SCO-1809). Bridge-only, JSON payload like openEventMenu; a harmless no-op
 * on plain web.
 *
 * `extra` rides along in the payload (`{ action, sport, ...extra }`) so an
 * action can carry its deep-link context — e.g. `seasons` sends
 * `{ seasonId, seasonName }`, `groups` sends `{ fid, aid }`, `club` sends
 * `{ clubAccount }` — which native appends to the destination section's URL
 * as query params. Old shells parse only `action` and ignore the rest.
 *
 * @param {string} action - action-vocabulary key ("find", "seasons", "groups", "club", "login", …)
 * @param {string} sport  - e.g. "cornhole" (native opens the sport-specific flow)
 * @param {object} [extra] - optional deep-link fields merged into the payload
 */
/**
 * SCO-2350 / SCO-2410: ask the shell for the native player login sheet.
 * EVERY webview host on both shells registers `showPlayerLogin` (SCO-2410);
 * after a login that CHANGED the identity the host reloads its page with
 * fresh credentials (FAT / FAC also re-open what was tapped, from the
 * payload). `reason` keys the sheet's intro line (player.json
 * `loginReason.*`: register / discuss / feed). Returns true when a handler
 * took the call — keep the old behavior (toast / web modal) on false (old
 * shells, plain web).
 */
// Opens native Find a Tournament from any host via the generic `openLink` router
// (a /tournament/ link with no id = the plain list). False when no handler took it.
export function openFindTournamentLink(sport) {
  const url = `https://app.scoreholio.com/${sport}/tournament/`;
  if (typeof window.Android?.openLink === "function") {
    window.Android.openLink(url);
    return true;
  }
  if (window.webkit?.messageHandlers?.openLink) {
    window.webkit.messageHandlers.openLink.postMessage(url);
    return true;
  }
  return false;
}

export function requestPlayerLogin(payload = {}) {
  const json = JSON.stringify(payload);
  if (typeof window.Android?.showPlayerLogin === "function") {
    window.Android.showPlayerLogin(json);
    return true;
  }
  if (window.webkit?.messageHandlers?.showPlayerLogin) {
    window.webkit.messageHandlers.showPlayerLogin.postMessage(json);
    return true;
  }
  return false;
}

// SCO-3066: tells the app whether the 2027 new look is on for every page; the native home's New look pop-up reads it.
export function postNewLookState(on) {
  try {
    if (typeof window.Android?.newLookState === "function") window.Android.newLookState(!!on);
    else if (window.webkit?.messageHandlers?.newLookState)
      window.webkit.messageHandlers.newLookState.postMessage({ on: !!on });
  } catch (e) {
    console.log("newLookState fail");
  }
}

export function postHomeAction(action, sport, extra = {}) {
  const payload = JSON.stringify({ action, sport: sport || "", ...extra });
  try {
    window.Android.homeAction(payload);
  } catch (e) {
    console.log("android homeAction fail");
  }
  try {
    window.webkit.messageHandlers.homeAction.postMessage(payload);
  } catch (e) {
    console.log("webkit homeAction fail");
  }
}

/**
 * Present an arbitrary React page as a native bottom sheet over the home, via
 * the same `openEventMenu` bridge message the event-card menu uses: iOS's
 * handler is a generic "present this relative URL as a pageSheet"
 * (EventMenuViewController — env-aware host prepend, content-hugging detent
 * via `menuHeight`, `closeModal` to dismiss), so any sheet page can ride it
 * with zero native change. Used by the hero match tap-through (SCO-1809) to
 * present `/home-events/match`. Bridge-only; a harmless no-op on plain web.
 *
 * @param {string} url - relative React URL (e.g. "/v2/cornhole/home-events/match?…")
 * @param {object} [extra] - optional presentation hints merged into the payload
 *   (e.g. `{ sheetBg: "modal" }` — native paints the sheet background like the
 *   web modal surface instead of the app-background blue). Old builds ignore
 *   unknown fields.
 */
export function postEventSheetUrl(url, extra = {}) {
  const payload = JSON.stringify({ url, ...extra });
  try {
    window.Android.openEventMenu(payload);
  } catch (e) {
    console.log("android openEventMenu fail");
  }
  try {
    window.webkit.messageHandlers.openEventMenu.postMessage(payload);
  } catch (e) {
    console.log("webkit openEventMenu fail");
  }
}

/**
 * Switch the whole app to another sport (SCO-2160). Native `setSport` persists
 * the sport app-wide and reloads the calling host on `/v2/<slug>/…`. Shells
 * without it fall back to the `changeSport` picker (organizer picks by hand);
 * plain web swaps the sport path segment itself.
 *
 * @param {string} slug - URL sport slug (e.g. "other")
 */
export function switchAppSport(slug) {
  if (typeof window.Android?.setSport === "function") {
    window.Android.setSport(slug);
    return;
  }
  if (window.webkit?.messageHandlers?.setSport) {
    window.webkit.messageHandlers.setSport.postMessage(
      JSON.stringify({ slug }),
    );
    return;
  }
  if (typeof window.Android?.changeSport === "function") {
    window.Android.changeSport();
    return;
  }
  if (window.webkit?.messageHandlers?.changeSport) {
    window.webkit.messageHandlers.changeSport.postMessage(
      JSON.stringify({ option: "changesport" }),
    );
    return;
  }
  const url = new URL(window.location.href);
  const parts = url.pathname.split("/");
  parts[2] = slug;
  url.pathname = parts.join("/");
  if (url.searchParams.has("sport")) url.searchParams.set("sport", slug);
  window.location.replace(url.toString());
}

const PENDING_CREATE_KEY = "sh.pendingCreateFormat";
const PENDING_CREATE_TTL_MS = 10 * 60 * 1000;

// Survives the native host reload a sport switch triggers.
export function setPendingCreateFormat(sport, format) {
  try {
    localStorage.setItem(
      PENDING_CREATE_KEY,
      JSON.stringify({ sport, format, ts: Date.now() }),
    );
  } catch (e) {
    console.log("pendingCreateFormat write fail");
  }
}

/** One-shot: returns the pending format for `sport` (and clears it), else null. */
export function takePendingCreateFormat(sport) {
  try {
    const raw = localStorage.getItem(PENDING_CREATE_KEY);
    if (!raw) return null;
    const pending = JSON.parse(raw);
    if (Date.now() - pending.ts > PENDING_CREATE_TTL_MS) {
      localStorage.removeItem(PENDING_CREATE_KEY);
      return null;
    }
    if (pending.sport !== sport) return null;
    localStorage.removeItem(PENDING_CREATE_KEY);
    return pending.format || null;
  } catch (e) {
    return null;
  }
}

export function DetermineEditLimitSpr(localStoragePlayer) {
  //If user has updated limitSpr within last 6 hours, return false, else return true
  const lastUpdatedDate =
    localStorage.hasOwnProperty("limitSpr") &&
    localStorage.getItem("limitSpr") !== null
      ? new Date(localStorage.getItem("limitSpr")).getTime()
      : null;
  const sixHoursAgo = new Date().getTime() - 21600000;
  if (lastUpdatedDate && lastUpdatedDate > sixHoursAgo) {
    //If lastUpdatedDate in ms is greater than sixHoursAgo in ms, it means it's been less than 6 hours since they last updated limitSpr
    // console.log("less than 6 hours ago");
    return false;
  } else {
    // console.log("more than 6 hours ago");
    return true;
  }
}

export function EditLimitSprTime(localStoragePlayer) {
  //Return the hours/minutes until they can edit limitSpr again
  const lastUpdatedDate =
    localStorage.hasOwnProperty("limitSpr") &&
    localStorage.getItem("limitSpr") !== null
      ? new Date(localStorage.getItem("limitSpr")).getTime()
      : null;
  // const sixHoursAgo = new Date().getTime() - 21600000;
  const sixHoursAgo = new Date().getTime() - 21600000;

  const diff = lastUpdatedDate - sixHoursAgo;
  const hours = Math.floor(diff / 3.6e6);
  const minutes = Math.floor((diff % 3.6e6) / 6e4);
  const duration = `${hours}hr ${minutes}min`;

  return duration;
}

// **************************
// Geocoding helper functions
const multipleAddressActions = (dispatch, data) => {
  dispatch({
    type: "customLat",
    customLat: data.lat,
  });
  dispatch({
    type: "customLng",
    customLng: data.lng,
  });
  dispatch({
    type: "customAddress",
    customAddress: data.response
      ? data.response.results[0].formatted_address
      : "Incorrect Zip/Address",
  });
  dispatch({
    type: "custom_distance",
    customDistance: data.location,
  });
};

export async function GeocodeLatLng(state, location, dispatch) {
  let lati = state.lat;
  let long = state.lng;
  console.log("GeocodeLatLng function: ", state, location);
  // SCO-2061: react-geocode throws synchronously on a non-string address
  // (typeof null === "object"), and every caller fires this without a catch —
  // validate at entry and route bad input to the "Incorrect Zip/Address" path
  // instead of letting the rejection escape unhandled.
  if (typeof location !== "string" || !location.trim()) {
    multipleAddressActions(dispatch, {
      lat: 0,
      lng: 0,
      response: null,
      location,
    });
    return;
  }
  try {
    await fromAddress(location).then(
      (response) => {
        console.log("Geocode response: ", response);
        const { lat, lng } = response.results[0].geometry.location;
        console.log("geocoded lat, lng: ", lat, lng);
        multipleAddressActions(dispatch, { lat, lng, response, location });
        // return { lat: lati, lng: long, response };
      },
      (error) => {
        console.error("geocode.fromAddress error: ", error);
        // return "error";
        multipleAddressActions(dispatch, {
          lat: 0,
          lng: 0,
          response: null,
          location,
        });
      }
    );
  } catch (error) {
    // SCO-2061: belt-and-braces — no rejection may escape a fire-and-forget call
    console.error("GeocodeLatLng error: ", error);
    multipleAddressActions(dispatch, {
      lat: 0,
      lng: 0,
      response: null,
      location,
    });
  }
}
// End Geocoding helper functions
// **************************

// **************************
// Pre-Reg Functions

function NameCheck(player, formattedName) {
  //Check to see if the player actually has first and last name set. If not, use display name
  console.log("NameCheck player: ", player);
  let name = "";
  if (
    player.userFirstName !== "" &&
    player.userFirstName !== "." &&
    player.userFirstName !== "No First"
  ) {
    name = formattedName;
  } else {
    name = player.userDisplayName;
  }
  console.log("NameCheck name: ", name);
  return name;
}

export function FormatRegistrationTeamNames(
  teammates,
  data,
  player,
  selectedTeam,
  setCustomName,
  type
) {
  // let formattedName = player.userDisplayName;
  console.log("FormatRegistrationTeamNames selectedTeam: ", selectedTeam);
  console.log("FormatRegistrationTeamNames type: ", type);
  console.log("FormatRegistrationTeamNames setCustomName: ", setCustomName);
  console.log("FormatRegistrationTeamNames data: ", data);
  console.log("FormatRegistrationTeamNames player: ", player);
  let formattedName =
    selectedTeam && selectedTeam !== "Create Team"
      ? selectedTeam
      : selectedTeam && selectedTeam === "Create Team"
      ? ""
      : player.userDisplayName
      ? player.userDisplayName
      : player.profileData
      ? player.profileData.displayName
      : "";
  //Determine the team name formatting based on team name type setting
  //If type param === 'single' we need to format for a single player only. Else format ALL teammates in an array and set the team name
  if (data.teamNameType === "Display Names") {
    if (type !== "single") {
      let name =
        selectedTeam === "Create Team"
          ? player.profileData.displayName
          : selectedTeam;
      teammates.forEach((p) => {
        name = `${name}/${p.userDisplayName}`;
      });
      setCustomName(name);
    } else {
      formattedName = `${player.userDisplayName}`;
    }
  } else if (data.teamNameType === "First and Last Name") {
    if (type !== "single") {
      let name =
        selectedTeam === "Create Team"
          ? NameCheck(
              player.profileData,
              `${player.profileData.firstName} ${player.profileData.lastName}`
            )
          : selectedTeam;
      teammates.forEach((p) => {
        name = `${name}/${NameCheck(
          p,
          `${p.userFirstName} ${p.userLastName}`
        )}`;
      });
      setCustomName(name);
    } else {
      formattedName = `${NameCheck(
        player,
        `${player.userFirstName} ${player.userLastName}`
      )}`;
    }
  } else if (data.teamNameType === "First Initial, Last Name") {
    if (type !== "single") {
      let name =
        selectedTeam === "Create Team"
          ? NameCheck(
              player.profileData,
              `${player.profileData.firstName.charAt(0)}. ${
                player.profileData.lastName
              }`
            )
          : selectedTeam;
      teammates.forEach((p) => {
        name = `${name}/${NameCheck(
          p,
          `${p.userFirstName.charAt(0)}. ${p.userLastName}`
        )}`;
      });
      setCustomName(name);
    } else {
      formattedName = `${NameCheck(
        player,
        `${player.userFirstName.charAt(0)}. ${player.userLastName}`
      )}`;
    }
  } else if (data.teamNameType === "First Name, Last Initial") {
    if (type !== "single") {
      let name =
        selectedTeam === "Create Team"
          ? NameCheck(
              player.profileData,
              `${
                player.profileData.firstName
              } ${player.profileData.lastName.charAt(0)}.`
            )
          : selectedTeam;
      teammates.forEach((p) => {
        name = `${name}/${NameCheck(
          p,
          `${p.userFirstName} ${p.userLastName.charAt(0)}.`,
        )}`;
      });
      setCustomName(name);
    } else {
      formattedName = `${NameCheck(
        player,
        `${player.userFirstName} ${player.userLastName.charAt(0)}.`,
      )}`;
    }
  } else if (data.teamNameType === "Custom Team Names" && type !== "single") {
    setCustomName(formattedName);
  }
  console.log("formattedName: ", formattedName);
  return formattedName;
}

// End Pre-Reg Functions
// **************************
